
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-studio/journeys/monitor",
      function () {
        return require("private-next-pages/customer-studio/journeys/monitor.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer-studio/journeys/monitor"])
      });
    }
  